/** Keeps the screen on while a mode is running, where the browser supports it. */
class Wakelock {
  sentinel: WakeLockSentinel | null = null;
  active = false;

  constructor() {
    // The browser drops the lock whenever the page is hidden; take it back.
    document.addEventListener('visibilitychange', () => {
      if (this.active && document.visibilityState === 'visible') {
        this.acquire();
      }
    });
  }

  private acquire() {
    navigator.wakeLock
      ?.request('screen')
      .then((sentinel) => {
        this.sentinel = sentinel;
      })
      .catch(() => {
        // Denied or unsupported; the screen will just dim as usual.
      });
  }

  start() {
    this.active = true;
    this.acquire();
  }

  stop() {
    this.active = false;
    this.sentinel?.release();
    this.sentinel = null;
  }
}

export default new Wakelock();
